import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import NamedDto from 'modules/base/dto/NamedDto';

export class ParositasAdatlapDto extends IdentifiableDto {
	constructor() {
		super();
		this.csomagNev = null;
		this.adatlapFilename = null;
		this.adatlapPath = null;
		this.vizsgaAdatlap = null;
	}

	setup(props) {
		super.setup(props);
		this.csomagNev = props.csomagNev;
		this.adatlapFilename = props.adatlapFilename;
		this.adatlapPath = props.adatlapPath;
		this.vizsgaAdatlap = props.vizsgaAdatlap !== null ? new NamedDto().setup(props.vizsgaAdatlap) : null;
		return this;
	}
}

export default ParositasAdatlapDto;
